export const business = {
  name: 'Kévin AutoVap',
  formerName: "Auto Vap' 60",
  since: 2016,
  phone: '06 48 03 98 10',
  phoneHref: 'tel:+33648039810',
  addressLine1: '4 Rue Chaude',
  addressLine2: '80160 Rogy',
  mapsHref: 'https://www.google.com/maps/search/?api=1&query=4+Rue+Chaude+80160+Rogy',
  hours: [
    { days: 'Lundi – Vendredi', time: '9h – 12h · 14h – 17h' },
    { days: 'Samedi – Dimanche', time: '9h – 12h' },
  ],
  payments: ['CB', 'Virement instantané', 'Espèces', 'Paylib'],
};

export const navItems = [
  { label: 'Accueil', to: '/' },
  { label: 'Prestations', to: '/prestations' },
  { label: 'Tarifs', to: '/tarifs' },
  { label: 'Galerie', to: '/galerie' },
  { label: 'Vidéos', to: '/videos' },
  { label: 'News', to: '/news' },
  { label: 'Contact', to: '/contact' },
];

export const bookingItem = { label: 'RDV en ligne', to: '/rdv-en-ligne' };

export const zones = [
  'Conty',
  'Ailly-sur-Noye',
  'Poix-de-Picardie',
  'Grandvilliers',
  'Crèvecœur-le-Grand',
  'Amiens',
  'Beauvais',
  'Clermont',
  'Quevauvillers',
  'Breteuil',
];

export const processSteps = [
  {
    title: 'Vous réservez',
    text: 'En ligne ou par téléphone, on choisit ensemble la prestation et le créneau.',
  },
  {
    title: 'Je viens chez vous',
    text: "À domicile ou au travail. Seule condition : une prise électrique accessible.",
  },
  {
    title: 'La vapeur agit',
    text: 'Sièges, tapis, plastiques, aérations : 99,9 % des bactéries éliminées, sans chimie agressive.',
  },
  {
    title: 'Vous reprenez la route',
    text: 'Un habitacle sain, une carrosserie qui brille. Comme au premier jour.',
  },
];
